export const tenantSwitch = '/tenant-switch';